import React, { Component } from 'react';
import { array, func, number, string } from 'prop-types';
import classnames from 'classnames';
import Select from '../Select/Select';
import './RoundingSetting.scss';

const propTypes = {
  className: string,
  handleRoundToSelect: func.isRequired,
  roundOptions: array,
  roundTo: number
};
const defaultProps = { roundOptions: [] };

const RoundingSetting = props => {
  const { className, handleRoundToSelect, roundOptions, roundTo } = props;
  const roundToDefaultOption = roundOptions.find(opt => opt.value === roundTo);
  const testId = 'jbr-rounding-setting';

  return (
    <div className="stat__group">
      <div className={classnames('rounding-setting', className)} data-test-id={testId + '-container'}>
        <h5 className="jbr__label-text">Round to Nearest</h5>
        <Select
          btnClass="btn-dark"
          defaultOption={roundToDefaultOption}
          dropdownClass="dropdown-dark"
          onSelect={handleRoundToSelect}
          options={roundOptions}
          testId={testId}
        />
      </div>
    </div>
  );
};

RoundingSetting.propTypes = propTypes;
RoundingSetting.defaultProps = defaultProps;
export default RoundingSetting;
